module.exports = __webpack_public_path__ + "img/2-7-3.96217443.png";